const actions = {
    GET_NOTES: 'notes/GET_NOTES',
    SET_NOTES: 'notes/SET_NOTES',

    GET_NOTE: 'note/GET_NOTE',
    SET_NOTE: 'note/SET_NOTE'
};

export default actions